<template>
  <div class="modal-content-container">
    <button
      v-if="closeButton"
      type="button"
      class="close-modal"
      @click="closeModal"
    >
      Fechar
    </button>
    <p class="modal-title" v-if="modalTitle">{{ modalTitle }}</p>
    <slot>
      <p class="default-message">Adicione o componente aqui</p>
    </slot>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ModalContentContainer',
  props: {
    modalTitle: String,
    closeButton: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapMutations({ updateModal: 'UPDATE_MODAL' }),
    closeModal() {
      this.updateModal({
        isVisible: false,
        component: null,
        canClose: null,
      });
    },
  },
  mounted() {
    this.updateModal({ canClose: this.closeButton });
  },
};
</script>

<style lang="scss" scoped>
.modal-content-container {
  position: relative;
  padding: 2rem 2.5rem 2.5rem;
  border-radius: 0.5rem;
  background-color: var(--content-box-background);
  box-shadow: var(--content-box-shadow);
  margin: auto;

  @media screen and (max-width: $sm) {
    padding: 1.5rem 1.5rem 2rem;
  }

  .close-modal {
    position: absolute;
    color: var(--light-text-color);
    top: 0.75rem;
    right: 0.75rem;
    font-size: 0.75rem;
    cursor: pointer;
    transition: opacity 150ms ease-out;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }

  .default-message {
    font-style: italic;
    color: var(--light-text-color);
  }

  .modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    color: var(--dark-text-color);
  }
}
</style>